'use client'

import { TSimpleReviewCount } from '@/entities/room'
import { cn } from '@/shared/lib'

import { SubHeading } from '../common'

type Props = {
  simpleReviews: TSimpleReviewCount[]
}

export const SimpleReview = ({ simpleReviews }: Props) => {
  return (
    <div className="space-y-4 @max-md:space-y-3">
      <SubHeading>게스트가 선택한 장점</SubHeading>

      <ul className={cn('flex flex-wrap gap-2 overflow-hidden')}>
        {simpleReviews.map(review => (
          <li key={review.simpleReviewTemplateId}>
            <div className="flex h-9 w-fit shrink-0 items-center gap-1.5 rounded-sm bg-gray-50 px-2.5 py-2">
              <span className="typo-label1 font-normal text-gray-600">
                {review.content}
              </span>
              <span className="typo-label2 font-medium text-black">
                {review.count}
              </span>
            </div>
          </li>
        ))}
      </ul>
    </div>
  )
}
